import ajax from "@/utils/ajax.js";

export default {
  async sendVerificationCodeAsync(input) {
    return await ajax.post("/customer/SendVerificationCodeAsync", input);
  },
  async registAsync(input) {
    return await ajax.post("/customer/RegistFromMobileAsync", input);
  },
  async loginFromWeChatAsync(input) {
    let response = await ajax.post("/customer/LoginFromWeChatAsync", input);
    return JSON.parse(response.result);
  },
  async getLoginVerificationCodeAsync() {
    let response = await ajax.get("/customer/GetLoginVerificationCodeAsync");
    return response.result;
  },
  async changePasswordAsync(input) {
    return await ajax.post("/customer/ChangePasswordAsync", input);
  },
  async resetPasswordAsync(input) {
    return await ajax.post(`/customer/ResetPasswordAsync`, input);
  },
  async getCustomerTypeComboboxItemsAsync() {
    const response = await ajax.get(
      "/customer/GetCustomerTypeComboboxItemsAsync"
    );
    return response.result;
  },
  async getForEditAsync(id) {
    const response = await ajax.get(`/customer/GetForEditAsync?id=${id}`);
    return response.result;
  },
  async getCustomerComboboxItemsAsync() {
    const response = await ajax.get(
      "/customer/GetCustomerComboboxItemsAsync"
    );
    return response.result;
  }
};
